import store from './store'

const microApps = [
  {
    name: 'knowledgeMap',
    entry: process.env.VUE_APP_MAP_CRE,
    activeRule: '/knowledgeMap'
  },
  {
    name: 'courseMap',
    entry: process.env.VUE_APP_MAP_COU,
    activeRule: '/courseMap'
  },  
  {
    name: 'specialtyMap',
    entry: process.env.VUE_APP_MAP_SPE,
    activeRule: '/specialtyMap'
  }
]

const apps = microApps.map(item => {
  return {
    ...item,
    container: '#subapp-viewport', // 子应用挂载的div
    props: {
      routerBase: item.activeRule, // 下发基础路由
      getGlobalState: store.getGlobalState // 下发getGlobalState方法
    }
  }
})

export default apps
